import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ClientJS } from "clientjs";
import "./login.css";
import ToastMessage from "../ToastMessage/ToastMessage";
import {
  signIn,
  getCaptcha,
  captchaVerification,
  sendOtp,
  verifyOtp,
} from "../../utils/request"; // Import Api Functions
import OTPInput from "react-otp-input";

const temp_res_data = {
  url: "http://localhost:3001",
  jwt: "dasdasdSADASWEREWFW$@#FDS%@#RDSFC@#R@",
};

const Login = () => {
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [timerCount, setTimerCount] = useState(0);
  const [showResendOTP, setShowResendOTP] = useState(false);
  const [verifySpin, setVerifySpin] = useState(false);
  const [otp, setOtp] = useState();

  // Extract callback URL from URL query parameters
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const callbackUrl = queryParams.get("callbackUrl") || temp_res_data.url;
  const clientId = queryParams.get("clientId");
  console.log("clientId", clientId);

  const navigate = useNavigate(); // Hook to navigate to another route

  // const handleSubmit = async (event) => {
  //   event.preventDefault(); // Prevent default form submission

  //   // Reset states before each submit attempt
  //   setIsLoading(true);
  //   setError("");
  //   setSuccessMessage("");

  //   try {
  //     // Retrieve OTP verification data from sessionStorage
  //     const otpVerificationData = JSON.parse(
  //       sessionStorage.getItem("otpVerificationData")
  //     );

  //     if (!otpVerificationData) {
  //       throw new Error("OTP verification data not found in session storage.");
  //     }

  //     // Destructure necessary values from otpVerificationData
  //     const { email, browser_id, token } = otpVerificationData;

  //     // Prepare userSignInData for OTP verification
  //     const userSignInData = {
  //       email, // User email from sessionStorage
  //       otp, // OTP from sessionStorage
  //       browser_id, // Browser ID from sessionStorage
  //       token,
  //     };

  //     console.log("Sending sign-in request:", userSignInData); // Debug sign-in data

  //     // Proceed to verify OTP
  //     const otpVerificationResponse = await verifyOtp(userSignInData); // Assuming verifyOtp is your API call

  //     // Check if OTP verification was successful
  //     if (otpVerificationResponse.success) {
  //       const token = otpVerificationResponse.accessToken;
  //       document.cookie = `authToken=${token}; domain=localhost; path=/;`;
  //       sessionStorage.setItem("authToken", token);
  //       localStorage.setItem("authToken", token);

  //       setSuccessMessage("Login successful!");
  //       const redirectUrl = new URL("http://localhost:3000/");
  //       redirectUrl.searchParams.set("authToken", token);

  //       setTimeout(() => {
  //         window.location.href = redirectUrl.toString();
  //       }, 1000);
  //       // Optionally, redirect the user or perform any other actions on success
  //     } else {
  //       throw new Error(
  //         otpVerificationResponse.message || "OTP verification failed."
  //       );
  //     }
  //   } catch (err) {
  //     // Handle any errors during the process
  //     console.error("Login failed:", err);
  //     setError(err.message || "An error occurred during login.");
  //   } finally {
  //     setIsLoading(false); // Reset loading state after the operation
  //   }
  // };


  const handleSubmit = async (event) => {
    event.preventDefault(); // Prevent default form submission

    // Reset states before each submit attempt
    setIsLoading(true);
    setError("");
    setSuccessMessage("");

    try {
      // Retrieve OTP verification data from sessionStorage
      const otpVerificationData = JSON.parse(
        sessionStorage.getItem("otpVerificationData")
      );

      if (!otpVerificationData) {
        throw new Error("OTP verification data not found in session storage.");
      }

      // Destructure necessary values from otpVerificationData
      const { email, browser_id, token } = otpVerificationData;

      // Prepare userSignInData for OTP verification
      const userSignInData = {
        email, // User email from sessionStorage
        otp, // OTP from sessionStorage
        browser_id, // Browser ID from sessionStorage
        token,
      };

      console.log("Sending sign-in request:", userSignInData); // Debug sign-in data

      // Proceed to verify OTP
      const otpVerificationResponse = await verifyOtp(userSignInData); // Assuming verifyOtp is your API call

      // Check if OTP verification was successful
      if (otpVerificationResponse.success) {
        const token = otpVerificationResponse.accessToken;

        // Check if the response code is 20
        if (otpVerificationResponse.code === 20) {
          // Save the response in sessionStorage under the name 'verifiedUser'
          sessionStorage.setItem("verifiedUser", JSON.stringify(otpVerificationResponse));

          // Navigate to client/temp-password
          window.location.href = '/client/temp-password'; // Redirect to the specified URL
          return; // Ensure the rest of the code does not execute
        } else {
          // Normal flow: Set the auth token and proceed
          document.cookie = `authToken=${token}; domain=localhost; path=/;`;
          sessionStorage.setItem("authToken", token);
          localStorage.setItem("authToken", token);
        }

        setSuccessMessage("Login successful!");
        const redirectUrl = new URL("http://localhost:3000/");
        redirectUrl.searchParams.set("authToken", token);

        setTimeout(() => {
          window.location.href = redirectUrl.toString();
        }, 1000);
        // Optionally, redirect the user or perform any other actions on success
      } else {
        throw new Error(
          otpVerificationResponse.message || "OTP verification failed."
        );
      }
    } catch (err) {
      // Handle any errors during the process
      console.error("Login failed:", err);
      setError(err.message || "An error occurred during login.");
    } finally {
      setIsLoading(false); // Reset loading state after the operation
    }
};


  const startTimer = (timeCounter) => {
    setTimerCount(timeCounter); // Set timer to the initial value
  };

  useEffect(() => {
    if (timerCount === 0) {
      setShowResendOTP(false);
    }
  }, [timerCount]);

  useEffect(() => {
    const otpVerificationData = JSON.parse(
      sessionStorage.getItem("otpVerificationData")
    );
    if (otpVerificationData && otpVerificationData.resendOtpTime) {
      const { resendOtpTime } = otpVerificationData;
      setTimerCount(resendOtpTime);
      setShowResendOTP(true);
    }
  }, []);

  useEffect(() => {
    if (timerCount === 0) return;

    const timerInterval = setInterval(() => {
      setTimerCount((prevState) => {
        if (prevState > 0) {
          return prevState - 1;
        }
        clearInterval(timerInterval); // Clear interval when timer reaches 0
        return 0;
      });
    }, 1000);

    return () => clearInterval(timerInterval); // Cleanup the interval on component unmount
  }, [timerCount]);


  // Handle OTP change
  const handleChange = (otpValue) => {
    setOtp(otpValue);
  };

  const handleResendOTP = async () => {
    console.log("Resend OTP");

    const otpVerificationData = JSON.parse(
      sessionStorage.getItem("otpVerificationData")
    );

    const { email } = otpVerificationData;

    // If CAPTCHA is successful, proceed to sign in
    const userData = {
      email: email, // Assuming 'email' is declared somewhere in the scope
    };

    try {
      // Send OTP request
      const res = await sendOtp(userData); // Assuming sendOtp returns the response with a 'resendOtpTime' property

      if (res && res.resendOtpTime) {
        setShowResendOTP(true);
        startTimer(res.resendOtpTime);
      } else {
        console.error("Failed to receive resendOtpTime in response.");
      }
    } catch (err) {
      setError(err.message || "loginError");
      console.error("Error sending OTP:", err);
    }
  };

  // useEffect(() => {
  //   const otpVerificationData = JSON.parse(
  //     sessionStorage.getItem("otpVerificationData")
  //   );

  //   const { email } = otpVerificationData;
  //   if (email) {
  //     setShowResendOTP(true);
  //   }
  // }, []);

  return (
    <div className="flex-container">
      <div className="form-section">
        <div>
          <div>
            <h4 className="title">{"Verify OTP"}</h4>
            <p className="description">
              {
                "Enter the OTP sent to your email to verify your identity and complete the sign-in process."
              }
            </p>
          </div>

          <div>
            <OTPInput
              numInputs={6}
              value={otp} // Bind the value of OTP input to the state
              onChange={handleChange} // Update state on change
              containerStyle={{
                display: "flex",
                alignItems: "center",
                gap: "10px", // Add space between the input boxes
                margin: "50px 0 0 0",
              }}
              inputStyle={{
                width: "35px",
                height: "35px",
                borderRadius: "5px",
                textAlign: "center",
                fontSize: "20px",
                border: "2px solid #d9d9d9",
              }}
              inputType="tel"
              renderSeparator={<span> </span>}
              renderInput={(props) => <input {...props} />}
            />

            {!verifySpin
              ? showResendOTP && (
                  <span
                    style={{
                      fontWeight: "600",
                      fontSize: "20px",
                      color: "black",
                    }}
                  >
                    Resend OTP in{" "}
                    <span
                      style={{
                        color: "red",
                      }}
                    >
                      {timerCount}s
                    </span>
                  </span>
                )
              : ""}
            {/* {!verifySpin
              ? showResendOTP && (
                  <button
                    style={{
                      borderColor: "#1890ff",
                      borderRadius: "4px",
                      display: "flex", // This ensures text and image are aligned horizontally
                      textAlign: "center", // Vertically centers the text and image
                      margin: "130px 0 0 0",
                    }}
                    onClick={handleSubmit}
                  >
                    {isLoading ? "verifying" : "Verify"}
                  </button>
                )
              : ""} */}

            {!verifySpin ? (
              timerCount === 0 && !showResendOTP ? (
                <button
                  type="default"
                  style={{
                    borderColor: "#1890ff",
                    borderRadius: "4px",
                    width: "auto",
                    display: "flex", // This ensures text and image are aligned horizontally
                    alignItems: "center", // Vertically centers the text and image
                    padding: "6px 12px", // Optional padding for spacing
                    margin: "20px 0 0 0",
                  }}
                  onClick={handleResendOTP}
                >
                  <img
                    src={require("../../assets/refresh.svg").default}
                    alt="refresh"
                    style={{
                      marginRight: "8px", // Optional: Adds space between the text and the image
                      width: "25px", // Optional: Sets the image size, you can adjust this as needed
                      height: "25px", // Optional: Sets the image size, you can adjust this as needed
                    }}
                  />
                  Resend OTP
                </button>
              ) : (
                ""
              )
            ) : (
              ""
            )}
          </div>
          <div className="input-group">
            {!verifySpin
              ? showResendOTP && (
                  <div
                    className="input-group"
                    style={{
                      textAlign: "center", // Vertically centers the text and image
                      display: "flex", // Use flexbox to center the button horizontally
                      // justifyContent: "center", // Center button horizontally
                    }}
                  >
                    <button
                      style={{
                        borderColor: "#1890ff",
                        borderRadius: "4px",
                        margin: "30px 0 0 0",
                        width: "50%",
                        // display: "flex", // This ensures the button contents are aligned horizontally
                        justifyContent: "center", // Center the text horizontally
                        // alignItems: "center", // Center the text vertically
                        textAlign: "center", // Ensure text is centered in the button
                      }}
                      onClick={handleSubmit}
                    >
                      {isLoading ? "verifying" : "verify"}
                    </button>
                  </div>
                )
              : ""}

            <ToastMessage
              message={error || successMessage}
              type={error ? "error" : "success"}
            />
          </div>
        </div>
      </div>
    </div>
  );
};
export default Login;
